import { useEffect, useState } from 'react';

/**
 * Valeur retardée : elle ne suit `value` qu'après `delayMs` sans changement.
 *
 * Sert aux requêtes déclenchées par une saisie ou un geste continu (dessin sur
 * carte) : sans ce palier, chaque frappe partirait au serveur pour un résultat
 * que personne n'a le temps de lire.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
